export enum AlertTypes {
  NOTIFICATION = "notification",
}
